import { slugify } from 'fym-common/src/utils/slugify';

/**
 * The address that the creation sheet suggests from a title (QA finding brk-21): lower case, and no
 * '-' at the start or the end. "<script>… Señal 🔥" gave "…-Senal-" before. The server slug column
 * is case-insensitive, so the lower case changes no match. Pure.
 */
export function titleSlugSuggestion(title: string): string {
  return slugify(title, { lowercase: true }).replace(/^-+|-+$/g, '');
}
